import {HashRouter, Route, Routes, useLocation} from 'react-router-dom';
import Home from "./Pages/Home";
import AboutUs from "./Pages/Company/AboutUs";
import PrivacyPolicy from "./Pages/Company/PrivacyPolicy";
import TermsOfService from "./Pages/Company/TermsOfService";
import CustomerSupport from "./Pages/Company/CustomerSupport";
import Login from "./Pages/Authentication/Login";
import Signup from "./Pages/Authentication/Signup";
import NotFound from "./Pages/NotFound";
import NavbarToggle from "./Components/NavbarToggle";
import Profile from "./Pages/Account/Profile";
import FooterToggle from "./Components/FooterToggle";
import Subscription from "./Pages/Account/Subscription";
import Settings from "./Pages/Account/Settings";
import Admin from "./Pages/Account/Admin";
import ChargebeeLoader from "./Components/ChargebeeLoader";
import ProtectedRoute from './Components/PotectedRoute';
import Preferences from "./Pages/Account/Preferences";
import Applications from "./Pages/Account/Applications";
import LinkSignUp from "./Pages/Authentication/LinkSignUp";
import Pricing from "./Pages/Company/Pricing";
import Enterprise from "./Pages/Company/Enterprise";
import CreatePassword from "./Pages/Account/CreatePassword";
import UpdatePassword from "./Pages/Account/UpdatePassword";
import BookMeeting from "./Pages/Account/BookMeeting";
import SpecialDeal from "./Pages/Account/SpecialDeal";
import {useEffect} from "react";


function App() {

    return (
    <HashRouter>
        <ScrollToTop />
        <ChargebeeLoader />
        <div className="app-container">
            <NavbarToggle/>
            <div className="content">
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/about" element={<AboutUs/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                    <Route path="/terms-of-service" element={<TermsOfService/>}/>
                    <Route path="/customer-support" element={<CustomerSupport/>}/>
                    <Route path="/subscription-pricing" element={<Pricing/>}/>
                    <Route path="/enterprise-solutions" element={<Enterprise/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/link-signup" element={<LinkSignUp/>}/>
                    <Route path="/account/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                    <Route path="/account/create-password" element={<ProtectedRoute><CreatePassword /></ProtectedRoute>} />
                    <Route path="/account/update-password" element={<ProtectedRoute><UpdatePassword /></ProtectedRoute>} />
                    <Route path="/account/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
                    <Route path="/account/special-deal" element={<ProtectedRoute><SpecialDeal /></ProtectedRoute>} />
                    <Route path="/account/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                    <Route path="/account/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                    <Route path="/account/preferences" element={<ProtectedRoute><Preferences /></ProtectedRoute>} />
                    <Route path="/account/book-meeting" element={<ProtectedRoute><BookMeeting /></ProtectedRoute>} />
                    <Route path="/account/applications" element={<ProtectedRoute><Applications /></ProtectedRoute>} />
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </div>
            <FooterToggle/>
        </div>
    </HashRouter>
    )
        ;
}

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default App;
